import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { editUserField, getAllFieldList } from '../homeManage/request';
export default {
  props: {
    page: {
      typeof: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      saveLoading: false,
      seletedQuentity: 0,
      listData: []
    };
  },
  methods: {
    openModal() {
      this.listData = [];
      getAllFieldList({
        type: this.page
      }).then(res => {
        this.visible = true;
        this.listData = res.map(item => {
          let obj = {
            id: item.id,
            titleName: item.titleName,
            fieldName: item.fieldName,
            isDefault: item.isDefault === 1,
            isLock: item.isLock === 1,
            isSelected: item.isSelected === 1,
            isDefaultLock: item.isLock === 1
          };
          return obj;
        });
        this.computedLock();
      });
    },
    handleOk() {},
    handleSubmit() {
      let selectIds = [];
      this.listData.forEach(item => {
        if (item.isSelected) {
          selectIds.push(item.id);
        }
      });
      let params = {
        type: this.page,
        thId: selectIds.join(',')
      };
      this.saveLoading = true;
      editUserField(params).then(res => {
        if (res) {
          this.saveLoading = false;
          this.visible = false;
          this.$emit('refreshList');
        }
      }, () => {
        this.saveLoading = false;
      });
    },
    reset() {
      this.listData.forEach(item => {
        if (item.isDefault) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }
      });
      this.computedLock();
      // this.visible = false;
    },
    handleCancel() {
      this.seletedQuentity = 0;
      this.listData = [];
      this.visible = false;
      this.saveLoading = false;
    },
    computedLock() {
      let checkedNum = 0;
      this.listData.forEach(item => {
        if (item.isSelected) {
          checkedNum++;
        }
      });
      this.seletedQuentity = checkedNum;
      if (this.seletedQuentity >= 11) {
        this.listData.forEach(item => {
          if (!item.isSelected) {
            item.isLock = true;
          } else {
            item.isLock = false;
          }
        });
      } else {
        this.listData.forEach(item => {
          item.isLock = false;
        });
      }
    },
    switchChange(value) {
      this.computedLock();
    }
  }
};